// client/src/hooks/useSmartSearch.js
import { useMemo } from "react";
import { tokenize, buildRowIndex, rowMatches } from "../search/smartSearch";

// stabile ctxKey-Generierung, selbst wenn ctx nicht useMemo-stabil ist
const CTX_IDS = new WeakMap();
let CTX_SEQ = 1;

function getCtxKey(ctx) {
  if (!ctx) return "__default__";
  if (typeof ctx !== "object") return String(ctx);
  if (ctx.cacheKey != null) return String(ctx.cacheKey);
  if (!CTX_IDS.has(ctx)) CTX_IDS.set(ctx, `ctx${CTX_SEQ++}`);
  return CTX_IDS.get(ctx);
}

export default function useSmartSearch(items, query, ctx) {
  const tokens = useMemo(() => tokenize(String(query ?? "")), [query]);

  const indexed = useMemo(() => {
    const cacheKey = getCtxKey(ctx);
    return (items || []).map((row) => ({
      row,
      idx: buildRowIndex(row, { ...ctx, cacheKey }),
    }));
  }, [items, ctx]);

  const filtered = useMemo(() => {
    if (!tokens.length) return indexed.map((x) => x.row);
    const out = [];
    for (const { row, idx } of indexed) {
      if (rowMatches(tokens, idx)) out.push(row);
    }
    return out;
  }, [indexed, tokens]);

  return filtered;
}
